import { Injectable } from '@angular/core';
import { FormsExtendedDataApiModel, ApplicationDTO } from '../../forms/forms.model';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';

@Injectable({
  providedIn: 'root'
})
export class FormDisplayService {

    constructor(
        private cvApiService: CVApiService
    ) { }

    public async loadFormDto(applicationId: number) {
        try {
            let response = await this.cvApiService.get<ApplicationDTO>(`/api/v1/forms/${applicationId}`);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (error) {
            console.error('Failed to load application.');
        }
    }

    public async loadFormExtendedData(applicationId: number) {
        try {
            let response = await this.cvApiService.get<FormsExtendedDataApiModel>(`/api/v1/formExtendedData?applicationId=${applicationId}&pullUnused=false`);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (error) {
            console.error('Failed to load extended data.');
        }
    }

    public async loadSelectedAnswers(applicationId: number, recordingId: number, monitorType: number) {
        try {
            let response = await this.cvApiService.get<Map<number, Array<string>>>(`/api/v1/forms/${applicationId}/${recordingId}/${monitorType}`);
            if (response.status_code >= 200 && response.status_code < 300) {
                let map: Map<number, Array<string>> = new Map();
                for (const [key, value] of Object.entries(response.data)) {
                    map.set(Number(key), [...value]);
                }

                return map;
            }
            else throw response;
        }
        catch (error) {
            console.error('Failed to load selected answers.');
        }
    }

    public async saveForm(recordingId: number, applicationId: number, isCalibration: boolean, answerMap: Map<number, Array<string>>) {
        try {
            let type: number = isCalibration ? 1 : 0;

            let entryList = [];
            for (let [key, value] of answerMap) {
                entryList.push({ "Key": key, "Value": [...value] });
            }

            let response = await this.cvApiService.post<ApplicationDTO>(`/api/v1/forms/${applicationId}/${recordingId}/${type}`, JSON.stringify(entryList));
            if (response.status_code >= 200 && response.status_code < 300)
                return true;
            else throw response;
        }
        catch (error) {
            console.error('Failed to save new form.');
        }
    }

    public async removeMonitoredRecording(recordingId: number, applicationId: number, isCalibration: boolean) {
        try {
            let type: number = isCalibration ? 1 : 0;

            let response = await this.cvApiService.delete<null>(`/api/v1/recordings/monitored?recordingId=${recordingId}&applicationId=${applicationId}&type=${type}`);
            if (response.status_code >= 200 && response.status_code < 300)
                return true;
            else throw response;
        }
        catch (error) {
            console.error('Failed to delete form.');
            return false;
        }
    }
}
